import React from 'react';
import { cn } from './cn.js';

export default function Select({ className, children, ...props }) {
  return (
    <select
      className={cn(
        'h-12 w-full rounded-2xl border border-ptcm-border dark:border-gray-800 bg-white/80 dark:bg-gray-900/50',
        'px-4 text-sm text-ptcm-ink dark:text-gray-100 transition-all',
        'focus:bg-white dark:focus:bg-gray-900 focus:outline-none focus:ring-2 focus:ring-ptcm-primary/20 focus:border-ptcm-primary',
        className
      )}
      {...props}
    >
      {children}
    </select>
  );
}

